import React from 'react';
import { Box, Typography } from '@mui/material';
import { CathleteResponse } from '../../../providers/DataProvider.types';

import { ReactComponent as Decor } from '../../../assets/cathleteCard/decor.svg';
import wlkn_coin24 from '../../../assets/common/icons/wlkn_coin24.svg';
import { getPositionMedal } from '../../../utils/helpers';

export const CathleteCard = ({
    cathlete,
    index,
    mode,
}: {
    cathlete: { clanPicture?: string } & CathleteResponse;
    index: number;
    mode: 'topClan' | 'topServer';
}) => {
    return (
        <Box
            sx={{
                backgroundColor: cathlete.palette[5] + '80',
                height: '217px',
                borderRadius: '20px',
                marginLeft: '20px',
                overflow: 'hidden',
                display: 'flex',
                pointerEvents: 'none',
            }}
        >
            <Box
                sx={{
                    width: '32px',
                    height: '32px',
                    position: 'absolute',
                    zIndex: 2,
                    right: '-15px',
                    top: '-15px',
                    backgroundColor: '#F6F9FC',
                    borderRadius: '50%',
                    border: '5px solid #F6F9FC',

                    '& img': {
                        height: '32px',
                        width: '32px',
                    },

                    '& div': {
                        height: '32px',
                        width: '32px',
                        transform: 'translate(-1px,-1px)',
                    },
                }}
            >
                {getPositionMedal(index + 1)}
            </Box>
            <Box
                sx={{
                    flexGrow: 1,
                    padding: '30px 0 30px 30px',
                }}
            >
                <Typography
                    sx={{
                        color: '#0F0E0E',
                        fontFamily: 'AvenirNext600',
                        fontSize: '20px',
                    }}
                >
                    {cathlete.given_name}
                </Typography>
                <Typography
                    sx={{
                        color: '#0F0E0E60',
                        fontFamily: 'AvenirNext400',
                        fontSize: '14px',
                        lineHeight: 'normal',
                        margin: '15px 0 10px 0',
                    }}
                >
                    {mode === 'topServer' ? 'Сlan affiliation' : 'Owner'}
                </Typography>
                <Box display={'flex'} alignItems={'center'} gap={'5px'}>
                    <Box
                        sx={{
                            borderRadius: '50%',
                            overflow: 'hidden',
                            minWidth: '24px',
                            height: '24px',
                            background: `url(${mode === 'topServer' ? cathlete.clanPicture : cathlete.avatar})`,
                            border: cathlete.clanPicture ? 'none' : '1px solid lightgrey',
                            backgroundSize: 'cover',
                        }}
                    ></Box>
                    <Typography
                        sx={{
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext500',
                            fontSize: '16px',
                        }}
                    >
                        {mode === 'topServer' ? cathlete.clan : cathlete.username}
                    </Typography>
                </Box>
                <Typography
                    sx={{
                        color: '#0F0E0E60',
                        fontFamily: 'AvenirNext400',
                        fontSize: '14px',
                        lineHeight: 'normal',
                        margin: '10px 0 5px 0',
                    }}
                >
                    Season earnings
                </Typography>
                <Box display={'flex'} gap={'5px'}>
                    <img src={wlkn_coin24} alt="walken coin"></img>
                    <Typography
                        sx={{
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext600',
                            fontSize: '20px',
                        }}
                    >
                        {Number(cathlete.wlkn.toFixed()).toLocaleString()}
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    width: '152px',
                    height: '217px',
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <img
                    style={{
                        position: 'absolute',
                        transform: 'scale(-1, 1) translateY(-10px) translateX(40px) rotate(10deg)',
                    }}
                    height={320}
                    src={`data:image/svg+xml;utf8,${encodeURIComponent(cathlete.photo)}`}
                    alt="cathlete"
                />
                <Box
                    sx={{
                        '& path': {
                            fill: cathlete.palette[4],
                            stroke: cathlete.palette[4],
                        },
                    }}
                >
                    <Decor></Decor>
                </Box>
            </Box>
        </Box>
    );
};
